export default {
  sectionTitle: 'Claim Milestones',
  sectionDescription: 'Dates of key handling events, recorded per claim.',
  emptyStateTitle: 'No claim milestones yet',
  emptyStateDescription: 'Start by adding the first milestone whose date is recorded on claims.',
  createMilestone: 'Create Milestone',
  addMilestone: 'Add Milestone',
  editMilestone: 'Edit Milestone',
  required: 'Required',
  keyMustBeUnique: 'Key must be unique',
  keyMustMatchPattern: 'Key may only contain lowercase letters, numbers and underscores',
  keyMustContainLetterOrNumber: 'Key must contain at least one letter or number',
  descriptionHelperText: 'Shown to the Conductor — say when this milestone is reached.',
  conditionsTitle: 'Applies only when…',
  conditionsDescription:
    'Leave empty to apply the milestone to every claim in its scope. With conditions, it is shown and recorded only on the claims that match them.',
  noConditionFields: 'No condition fields available for this scope.',
  validationErrorsTitle: 'Please fix the following before saving:',
  cancel: 'Cancel',
  save: 'Save',
  labels: {
    name: 'Name',
    key: 'Key',
    description: 'Description',
    active: 'Active',
  },
  columns: {
    name: 'Name',
    key: 'Key',
    subOrgs: 'Sub Orgs',
    lobs: 'Lines of Business',
    conditional: 'Conditional',
    active: 'Active',
    actions: 'Actions',
  },
  conditional: {
    yes: 'Yes',
    no: 'No',
  },
} as const;
